import { useEffect, useState } from "react";

import '../../../../styles/stepper.css'
import ImageCaptureForMobile from "../../../../components/ImageCaptureForMobile";
import PDFViewer from "../../../../components/PDFViewer";
import PDFUploader from "../../../../pages/PDFUploader";
import PDFImageViewer from "../../../../components/PDF_ImageViewer";
import DatePicker from "react-datepicker";
import PDFImageViewer2 from "../../../../components/PDFImageViewer2";
import MultiFileUploader from "../../../../components/MultiFileUploader";




const Page2 = ({ formData, setFormData, nextPage, prevPage }) => {
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (!formData.lawyerImageNotary) newErrors.lawyerImageNotary                   = "Lawyer Image is required.";
    if (!formData.lawyerImageNotarySignature) newErrors.lawyerImageNotarySignature = "Signature is required.";

    // if (!formData.lawyerNotaryName) newErrors.lawyerNotaryName                     = "Notarial Name is required.";
    if (!formData.lawyerNotaryRollNo) newErrors.lawyerNotaryRollNo                 = "Roll Number is required.";
    if (!formData.lawyerCommissionNo) newErrors.lawyerCommissionNo                 = "Commission Number is required.";
    if (!formData.lawyerCommissionExpiryDate) newErrors.lawyerCommissionExpiryDate = "Expiry date is required.";
    if (!formData.lawyerPTRNo) newErrors.lawyerPTRNo                               = "PTR Number is required.";
    if (!formData.lawyerPTRDateIssued) newErrors.lawyerPTRDateIssued               = "PTR Date Issued is required.";
    if (!formData.lawyerPTRPlaceOfIssue) newErrors.lawyerPTRPlaceOfIssue           = "PTR Place of Issue is required.";
    if (!formData.lawyerIBPNo) newErrors.lawyerIBPNo                               = "IBP Number is required.";
    // if (!formData.lawyerComplianceNo) newErrors.lawyerComplianceNo                 = "Compliance Number is required.";
    // if (!formData.lawyerComplianceDateIssued) newErrors.lawyerComplianceDateIssued = "Date Issued is required.";
    // if (!formData.lawyerNotarialEmail) newErrors.lawyerNotarialEmail               = "Notarial Email is required.";
    if (!formData.lawyerNotarialAddress) newErrors.lawyerNotarialAddress           = "Notarial Address is required.";




    setErrors(newErrors);

    // Scroll to the first invalid element
    setTimeout(() => {
    const firstInvalidElement = document.querySelector('.invalid-feedback');
      if (firstInvalidElement) {
        firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstInvalidElement.focus?.();
      }
    }, 0);


    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validate()) {
      nextPage();
    }
  };
 
  const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file); // This converts to base64 string
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  const handleImageChange =async (image,keyName) => {
      if (image instanceof File) {
        const base64 = await fileToBase64(image);
        setFormData((prev) => ({
          ...prev,
          [keyName]: base64,
        }));
      }
      else{
         setFormData({ ...formData, [keyName]: image });
      }
  };


 


  const [cameras, setCameras] = useState([]);

  useEffect(() => {
    // Function to fetch available cameras
    const fetchCameras = async () => {
      try {
        // Get all devices
        const devices = await navigator.mediaDevices.enumerateDevices();
        
        // Filter video input devices (cameras)
        const videoDevices = devices.filter(device => device.kind === 'videoinput');
        
        // Set the video devices into state
        setCameras(videoDevices);
      } catch (err) {
        console.error('Error fetching devices: ', err);
      }
    };

    // Call the function to fetch cameras
    fetchCameras();
  }, []);


  useEffect(() => {
    console.log(formData);
  }, [formData]);


  const handleDateChange = (date,key) => {
    setFormData({
      ...formData,
      [key]: date ? date : "",
    });
  };

  const handleFilesChange = (files) => {
    console.log("Uploaded files:", files);
    // Each item: { file, customName, previewUrl }
  };

  return (
    <div className="step-content">



      {/* Notarial Info */}
      <div className="row mb-4" >



            {/* <PDFImageViewer2 btnCameraTitle="Scan Documents" title="Documents" subtitle="Scan notarial documents" onImageChange={handlePDFImageChange} keyName="scannedImages" preLoadedImage={formData.scannedImages} />
          {!formData.scannedImages && errors.scannedImages && <div className="invalid-feedback d-block blink">{errors.scannedImages}</div>} */}

        

      <div className="col-xs-12 col-md-6">
           <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="d-flex flex-column justify-content-center">
                <h5 className="mb-1">Lawyer's Image</h5>
                <p className="mb-1"><span className="fw-medium">Take a photo of a Lawyer</span></p>
              </div>
            </div>



          <div className="card shadow-none mt-4">
            <ImageCaptureForMobile
              signatureError={errors.lawyerImageNotarySignature}
              imageError={errors.lawyerImageNotary}
              btnCameraTitle="Open Camera" title="Lawyer Photo" subtitle="Take a photo of a Lawyer" onImageChange={handleImageChange} keyName="lawyerImageNotary" preLoadedImage={formData.lawyerImageNotary} useSignaturePad={true} preLoadedSignature={formData.lawyerImageNotarySignature} hasUploadButton={false} hasRemoveButton={true} info={"Captured image will be shown here."} />
            {/* {!formData.lawyerImageNotary && errors.lawyerImageNotary && <div className="invalid-feedback d-block blink ms-4">{errors.lawyerImageNotary}</div>}
            {!formData.lawyerImageNotarySignature && errors.lawyerImageNotarySignature && <div className="invalid-feedback d-block blink ms-4 mb-4">{errors.lawyerImageNotarySignature}</div>} */}
          
          </div>
        </div>



        <div className="col-xs-12 col-md-6">

          <div className="row">
             <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="d-flex flex-column justify-content-center">
                <h5 className="mb-1">Notarial Information</h5>
                <p className="mb-1"><span className="fw-medium">Fill-up info</span></p>
              </div>
            </div>

            <div className="col-md-12 col-xs-6 col-xs-12 mb-2 d-none">
              <label className="form-label text-info" htmlFor="lawyerNotaryName" >
                Notary Name <span className="text-danger fs-5 ms-1 mt-2">*</span>
              </label>
              <input
                type="text"
                className={`form-control text-uppercase mt-n1 ${!formData.lawyerNotaryName && errors.lawyerNotaryName && 'is-invalid'}`}
                id="lawyerNotaryName"
                value={formData.lawyerNotaryName}
                name="lawyerNotaryName"
                placeholder="Enter Notary Name"
                aria-label="Notary Name"
                onChange={(e) => setFormData({ ...formData, lawyerNotaryName: e.target.value })}
              />
              {!formData.lawyerNotaryName && errors.lawyerNotaryName && <div className="invalid-feedback d-block blink">{errors.lawyerNotaryName}</div>}

            </div>

            <div className="col-md-12 col-xs-6 mb-2">
              <label className="form-label text-info" htmlFor="lawyerNotaryRollNo" >
               Atty. Roll Number <span className="text-danger fs-5 ms-1 mt-2">*</span>
              </label>
              <input
                type="text"
                className={`form-control text-uppercase mt-n1 ${!formData.lawyerNotaryRollNo && errors.lawyerNotaryRollNo && 'is-invalid'}`}
                id="lawyerNotaryRollNo"
                value={formData.lawyerNotaryRollNo}
                name="lawyerNotaryRollNo"
                placeholder="Enter Roll No"
                aria-label="Roll No"
                onChange={(e) => setFormData({ ...formData, lawyerNotaryRollNo: e.target.value })}
              />
              {!formData.lawyerNotaryRollNo && errors.lawyerNotaryRollNo && <div className="invalid-feedback d-block blink">{errors.lawyerNotaryRollNo}</div>}

            </div>

             <div className="col-md-12 col-xs-6 mb-2">
              <label className="form-label text-info" htmlFor="lawyerIBPNo" >
                IBP Number <span className="text-danger fs-5 ms-1 mt-2">*</span>
              </label>
              <input
                type="text"
                className={`form-control text-uppercase mt-n1 ${!formData.lawyerIBPNo && errors.lawyerIBPNo && 'is-invalid'}`}
                id="lawyerIBPNo"
                value={formData.lawyerIBPNo}
                name="place_of_birth"
                placeholder="IBP No"
                aria-label="IBP No"
                onChange={(e) => setFormData({ ...formData, lawyerIBPNo: e.target.value })}
              />
              {!formData.lawyerIBPNo && errors.lawyerIBPNo && <div className="invalid-feedback d-block blink">{errors.lawyerIBPNo}</div>}
            </div>



            <div className="col-md-12 col-xs-6 mb-2">
              <label className="form-label text-info" htmlFor="lawyerCommissionNo" >
                Court Commissioned Number <span className="text-danger fs-5 ms-1 mt-2">*</span>
              </label>
              <input
                type="text"
                className={`form-control text-uppercase mt-n1 ${!formData.lawyerCommissionNo && errors.lawyerCommissionNo && 'is-invalid'}`}
                id="lawyerCommissionNo"
                value={formData.lawyerCommissionNo}
                name="lawyerCommissionNo"
                placeholder="Enter Commission no"
                aria-label="Commission No"
                onChange={(e) => setFormData({ ...formData, lawyerCommissionNo: e.target.value })}
              />
              {!formData.lawyerCommissionNo && errors.lawyerCommissionNo && <div className="invalid-feedback d-block blink">{errors.lawyerCommissionNo}</div>}

            </div>

    
            <div className="col-md-12 col-xs-6 mb-2">
              <label className="form-label text-info d-block " htmlFor="lawyerCommissionExpiryDate" >
                Expiry Date <span className="text-danger fs-5 ms-1 mt-2">*</span>
              </label>
              <DatePicker
                id="lawyerCommissionExpiryDate"
                name="lawyerCommissionExpiryDate"
                className={`form-control text-uppercase flatpickr-input active w-100 mt-n1 ${!formData.lawyerCommissionExpiryDate && errors.lawyerCommissionExpiryDate && 'is-invalid'}`}
                placeholderText="YYYY-MM-DD"

                 selected={formData.lawyerCommissionExpiryDate ? new Date(formData.lawyerCommissionExpiryDate) : null}

                onChange={(date) => handleDateChange(date, "lawyerCommissionExpiryDate")}

                dateFormat="yyyy-MM-dd"

                showYearDropdown
                showMonthDropdown
                dropdownMode="select"

                minDate={new Date()}

              />
              {!formData.lawyerCommissionExpiryDate && errors.lawyerCommissionExpiryDate && <div className="invalid-feedback d-block blink">{errors.lawyerCommissionExpiryDate}</div>}
            </div>


            <div className="col-md-12 col-xs-6 mb-2">
              <label className="form-label text-info" htmlFor="lawyerPTRNo" >
                PTR Number <span className="text-danger fs-5 ms-1 mt-2">*</span>
              </label>
              <input
                type="text"
                className={`form-control text-uppercase mt-n1 ${!formData.lawyerPTRNo && errors.lawyerPTRNo && 'is-invalid'}`}
                id="lawyerPTRNo"
                value={formData.lawyerPTRNo}
                name="lawyerPTRNo"
                placeholder="Enter PTR No"
                aria-label="PTR No"
                onChange={(e) => setFormData({ ...formData, lawyerPTRNo: e.target.value })}
              />
              {!formData.lawyerPTRNo && errors.lawyerPTRNo && <div className="invalid-feedback d-block blink">{errors.lawyerPTRNo}</div>}
            </div>




            <div className="col-md-12 col-xs-6 mb-2">
              <label className="form-label text-info d-block " htmlFor="lawyerPTRDateIssued" >
                PTR Date Issued <span className="text-danger fs-5 ms-1 mt-2">*</span>
              </label>
              <DatePicker
                id="lawyerPTRDateIssued"
                name="lawyerPTRDateIssued"
                className={`form-control text-uppercase flatpickr-input active w-100 mt-n1 ${!formData.lawyerPTRDateIssued && errors.lawyerPTRDateIssued && 'is-invalid'}`}
                placeholderText="YYYY-MM-DD"
 
                 selected={formData.lawyerPTRDateIssued ? new Date(formData.lawyerPTRDateIssued) : null}


                onChange={(date) => handleDateChange(date, "lawyerPTRDateIssued")}

                dateFormat="yyyy-MM-dd"

                showYearDropdown
                showMonthDropdown
                dropdownMode="select"

                minDate={new Date('1940-01-01')}
                maxDate={new Date()}


              />
              {!formData.lawyerPTRDateIssued && errors.lawyerPTRDateIssued && <div className="invalid-feedback d-block blink">{errors.lawyerPTRDateIssued}</div>}
            </div>

            <div className="col-md-12 col-xs-6 mb-2">
              <label className="form-label text-info" htmlFor="lawyerPTRPlaceOfIssue" >
                PTR Place Issued <span className="text-danger fs-5 ms-1 mt-2">*</span>
              </label>
              <input
                type="text"
                className={`form-control text-uppercase mt-n1 ${!formData.lawyerPTRPlaceOfIssue && errors.lawyerPTRPlaceOfIssue && 'is-invalid'}`}
                id="lawyerPTRPlaceOfIssue"
                value={formData.lawyerPTRPlaceOfIssue}
                name="lawyerPTRPlaceOfIssue"
                placeholder="Place of Issue"
                aria-label="Place of Issue"
                onChange={(e) => setFormData({ ...formData, lawyerPTRPlaceOfIssue: e.target.value })}
              />
              {!formData.lawyerPTRPlaceOfIssue && errors.lawyerPTRPlaceOfIssue && <div className="invalid-feedback d-block blink">{errors.lawyerPTRPlaceOfIssue}</div>}
            </div>

            
           


            <div className="col-md-12 col-xs-6 mb-2 d-none">
              <label className="form-label text-info" htmlFor="lawyerComplianceNo" >
                Compliance Number <span className="text-danger fs-5 ms-1 mt-2">*</span>
              </label>
              <input
                type="text"
                className={`form-control text-uppercase mt-n1 ${!formData.lawyerComplianceNo && errors.lawyerComplianceNo && 'is-invalid'}`}
                id="lawyerComplianceNo"
                value={formData.lawyerComplianceNo}
                name="place_of_birth"
                placeholder="Enter Compliance No"
                aria-label="Compliance No"
                onChange={(e) => setFormData({ ...formData, lawyerComplianceNo: e.target.value })}
              />
              {!formData.lawyerComplianceNo && errors.lawyerComplianceNo && <div className="invalid-feedback d-block blink">{errors.lawyerComplianceNo}</div>}
            </div>



            <div className="col-md-12 col-xs-6 mb-2 d-none">
              <label className="form-label text-info d-block " htmlFor="lawyerComplianceDateIssued" >
                Compliance Date Issued <span className="text-danger fs-5 ms-1 mt-2">*</span>
              </label>
              <DatePicker
                id="lawyerComplianceDateIssued"
                name="lawyerComplianceDateIssued"
                className={`form-control text-uppercase flatpickr-input active w-100 mt-n1 ${!formData.lawyerComplianceDateIssued && errors.lawyerComplianceDateIssued && 'is-invalid'}`}
                placeholderText="YYYY-MM-DD"

                selected={formData.lawyerComplianceDateIssued ? new Date(formData.lawyerComplianceDateIssued) : null}


                onChange={(date) => handleDateChange(date, "lawyerComplianceDateIssued")}

                dateFormat="yyyy-MM-dd"

                showYearDropdown
                showMonthDropdown
                dropdownMode="select"

                minDate={new Date('1940-01-01')}
                maxDate={new Date()}


              />
              {!formData.lawyerComplianceDateIssued && errors.lawyerComplianceDateIssued && <div className="invalid-feedback d-block blink">{errors.lawyerComplianceDateIssued}</div>}
            </div>

            <div className="col-md-12 mb-2 d-none">
              <label className="form-label text-info" htmlFor="lawyerNotarialEmail" >
                Notarial Email <span className="text-danger fs-5 ms-1 mt-2">*</span>
              </label>
              <input
                type="text"
                className={`form-control text-uppercase mt-n1 ${!formData.lawyerNotarialEmail && errors.lawyerNotarialEmail && 'is-invalid'}`}
                id="lawyerNotarialEmail"
                value={formData.lawyerNotarialEmail}
                name="place_of_birth"
                placeholder="Enter Notarial Email"
                aria-label="Enter Notarial Email"
                onChange={(e) => setFormData({ ...formData, lawyerNotarialEmail: e.target.value })}
              />
              {!formData.lawyerNotarialEmail && errors.lawyerNotarialEmail && <div className="invalid-feedback d-block blink">{errors.lawyerNotarialEmail}</div>}
            </div>

            <div className="col-md-12 mb-2">
              <label className="form-label text-info" htmlFor="lawyerNotarialAddress" >
                Office / Notarial Address <span className="text-danger fs-5 ms-1 mt-2">*</span>
              </label>
              <input
                type="text"
                className={`form-control text-uppercase mt-n1 ${!formData.lawyerNotarialAddress && errors.lawyerNotarialAddress && 'is-invalid'}`}
                id="lawyerNotarialAddress"
                value={formData.lawyerNotarialAddress}
                name="lawyerNotarialAddress"
                placeholder="Enter Notarial Address"
                aria-label="Notarial Address"
                onChange={(e) => setFormData({ ...formData, lawyerNotarialAddress: e.target.value })}
              />
              {!formData.lawyerNotarialAddress && errors.lawyerNotarialAddress && <div className="invalid-feedback d-block blink">{errors.lawyerNotarialAddress}</div>}
            </div>



           
 

        

          </div>

        </div>
        
        <div className="col-md-7 d-none">
         <MultiFileUploader title={"UPLOAD NECESSARY FILES"} onImageChange={handleFilesChange} formData={formData} setFormData={setFormData} />
        </div>

     

      </div>
  
  
      {/* End Notarial Info */}




{/* 
      <hr className="my-4 px-0" /> */}


     
  
 


      <div className="row">
        <div className="col-12 d-flex justify-content-between">
          <button className="btn btn-label-secondary btn-prev" onClick={prevPage}>
            <i className="bx bx-chevron-left bx-sm ms-sm-n2" />
            <span className="align-middle d-sm-inline-block d-none">
              Previous
            </span>
          </button>
          <button className="btn btn-primary btn-next" onClick={handleNext}>
            <span className="align-middle d-sm-inline-block  d-none  me-sm-1">
              Next
            </span>
            <i className="bx bx-chevron-right bx-sm me-sm-n2" />
          </button>
        </div>
      </div>


    </div>
  );
};

export default Page2;
